import { render } from "./JardinerCard.vue?vue&type=template&id=639e21d8"
import script from "./JardinerCard.vue?vue&type=script&lang=js"
export * from "./JardinerCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__